import { DeleteFilled } from "@ant-design/icons";
import { useAppMemo } from "../../constants/hooks";

export const DeleteIcon = () => {
  return useAppMemo(() => {
    return <DeleteFilled className="delete-icon" />;
  }, []);
};
